module.exports = __webpack_public_path__ + "img/d-11.28e537d4.png";